export default __webpack_public_path__ + "static/media/arrow-select.1701f9fe.svg";